import Text from '@deprecated-ui/common/Text';
import { formatNumber } from 'utils/number';
import { BidOfferWrapper, BidOffer, LeftBox, RightBox } from './styled';

interface BidOfferBoxProps {
  orderbook: {
    bid: {
      price: string;
    };
    offer: {
      price: string;
    };
  };
}

function BidOfferBox({ orderbook }: BidOfferBoxProps) {
  const { bid, offer } = orderbook;
  const bidPrice = bid.price ? formatNumber(bid.price, false) : '-';
  const offerPrice = offer.price ? formatNumber(offer.price, false) : '-';

  return (
    <BidOfferWrapper>
      {/* @ts-expect-error */}
      <BidOffer mr="10px">
        <LeftBox>
          <Text>B</Text>
        </LeftBox>
        <RightBox>
          <Text>{bidPrice}</Text>
        </RightBox>
      </BidOffer>
      <BidOffer>
        <LeftBox>
          <Text>O</Text>
        </LeftBox>
        <RightBox>
          <Text>{offerPrice}</Text>
        </RightBox>
      </BidOffer>
    </BidOfferWrapper>
  );
}

export default BidOfferBox;
